import firebase from "firebase/compat/app";
import { useEffect, useState } from "react";
import useEsgSurveyQuestions from './useEsgSurveyQuestions';
import useEsgSurveyResponsesStandalone from './useEsgSurveyResponsesStandalone';


const useGetAdminDataStandalone = ({ orgId = "none", periodId, isStandalone }) => {

    const {
        internalSurveyResponses,
        externalSurveyResponses,
        adminSurveyResponses,
    } = useEsgSurveyResponsesStandalone({ orgId, periodId, isStandalone });

    const { currentSurvey, setRefresh, currentVersionIdPath } = useEsgSurveyQuestions({ orgId, periodId, isStandalone });

    // console.log("isStandalone", isStandalone);


    const [respondentName, setRespondentName] = useState("");
    useEffect(() => {
        if (respondentName) return;
        if (isStandalone) {
            setRespondentName(internalSurveyResponses?.orgName || "");
            return;
        }
        const getOrgName = async () => {
            try {
                const orgData = await firebase
                    .firestore()
                    .collection("organisations")
                    .doc(orgId)
                    .get();

                setRespondentName(orgData.data()?.name);
            } catch (e) {
                console.log(e);
            }
        };
        getOrgName();
    }, [internalSurveyResponses]);


    return {
        internalSurveyResponses,
        externalSurveyResponses,
        adminSurveyResponses,
        currentSurvey,
        setRefresh,
        respondentName,
        currentVersionIdPath,
    }

}

export default useGetAdminDataStandalone